var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
import React from 'react';
import { SvgCircleIcon } from './svg-circle-icon';
export var FlickrIcon = function (props) {
  return React.createElement(SvgCircleIcon, __assign({}, props, {
    glyphWidth: 52,
    glyphHeight: 22
  }), React.createElement("circle", {
    cx: "10.4",
    cy: "10.9332",
    r: "10.4"
  }), React.createElement("circle", {
    cx: "41.6",
    cy: "10.9332",
    r: "10.4"
  }));
};
export var FlickrIconGlyph = function (props) {
  return React.createElement(FlickrIcon, __assign({}, props, {
    variant: 'glyph'
  }));
};